import { Component, OnInit } from "@angular/core";
import {
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from "@angular/router";

import { IconService } from "./core/services/icon.service";
import { LoaderService } from "./core/services/loader.service";
import { WindowRef } from "./core/common/global-refs";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  exitBackendPreview,
  initPreviewEnvironment,
} from "./core/utils/preview-environment";

@Component({
  selector: "cp-app",
  template: `
    <ngx-spinner
      type="line-scale"
      size="medium"
      color="#7CAF41"
      bdColor="rgba(255,255,255,0.8)"
    ></ngx-spinner>
    <router-outlet></router-outlet>
    <div *ngIf="previewEnvironment" class="backend-preview-banner">
      <span>Backend preview: PR #{{ previewEnvironment }}</span>
      <button type="button" (click)="exitPreview()">Exit Preview</button>
    </div>
  `,
  styles: [
    `
      .backend-preview-banner {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000002;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        padding: 6px 12px;
        background: #f59e0b;
        color: #fff;
        font: bold 13px/1.4 sans-serif;
      }

      .backend-preview-banner button {
        background: #000;
        color: #f59e0b;
        border: 1px solid #000;
        border-radius: 4px;
        padding: 2px 10px;
        font: bold 12px/1.4 sans-serif;
        cursor: pointer;
      }
    `,
  ],
  standalone: false,
})
export class AppComponent implements OnInit {
  previewEnvironment: string | null = null;
  exitPreview = exitBackendPreview;

  constructor(
    private readonly router: Router,
    private readonly loaderService: LoaderService,
    private readonly iconService: IconService,
    private readonly windowRef: WindowRef,
  ) {}
  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.previewEnvironment = initPreviewEnvironment();

    if (this.windowRef.nativeWindow.pendo) {
      this.windowRef.nativeWindow.pendo.initialize();
    }
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loaderService.pushRequest();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loaderService.removeRequest();
      }
    });

    this.iconService.registerIcons();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
